import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=a33aea64&lang=pug&"
import script from "./Archive.vue?vue&type=script&lang=js&"
export * from "./Archive.vue?vue&type=script&lang=js&"
import style0 from "./Archive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a33aea64')) {
      api.createRecord('a33aea64', component.options)
    } else {
      api.reload('a33aea64', component.options)
    }
    module.hot.accept("./Archive.vue?vue&type=template&id=a33aea64&lang=pug&", function () {
      api.rerender('a33aea64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Archive.vue"
export default component.exports